/**
 * «المخزون» backend error codes. Must match `ErrorCodes` in be/utils/errors.js (Stock group, STOCK_xxx).
 * Codes are the contract; config/stockLabels.js turns them into words.
 * Pattern reference: web/src/utils/unitStopErrorCodes.js
 */
export const STOCK_ERROR_CODES = {
  STORE_NOT_FOUND: 'STOCK_001',
  ITEM_NOT_FOUND: 'STOCK_002',
  ENTRY_NOT_FOUND: 'STOCK_003',
  NAME_REQUIRED: 'STOCK_004',
  NAME_TOO_LONG: 'STOCK_005',
  NAME_TAKEN: 'STOCK_006',
  NOTE_INVALID: 'STOCK_007',
  UNIT_INVALID: 'STOCK_008',
  UNIT_LOCKED: 'STOCK_009',
  LEVEL_INVALID: 'STOCK_010',
  QUANTITY_INVALID: 'STOCK_011',
  LINES_EMPTY: 'STOCK_012',
  LINES_DUPLICATE: 'STOCK_013',
  LINES_INVALID: 'STOCK_014',
  ITEM_ARCHIVED: 'STOCK_015',
  NOT_REVERSIBLE: 'STOCK_016',
  TAKER_REQUIRED: 'STOCK_017',
  TAKER_INVALID: 'STOCK_018',
  PERIOD_INVALID: 'STOCK_019',
  KEY_REQUIRED: 'STOCK_020',
  KEY_CONFLICT: 'STOCK_021',
  PHOTO_REQUIRED: 'STOCK_022',
  PHOTO_TOO_LARGE: 'STOCK_023',
  PHOTO_BAD_TYPE: 'STOCK_024',
};
